export class LoginRequest {
  //metadata
  public email: string;
  public password: string;

}
